// import logo from './logo.svg';
// import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home'
import About from './pages/About'
import Projects from './pages/Projects'
import Services from './pages/Services'
import Contact from './pages/Contact'
import Blogs from './pages/Blogs'
import BlogDetails from './pages/BlogDetails'
import ServicesDetails from './pages/ServicesDetails'
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Events from './pages/Events';
import EventsDetails from './pages/EventsDetails';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';
import NotFound from './components/NotFound/NotFound';
// import Sidebar from './components/Sidebar/Sidebar';

function App() {
  return (
    <div className="App">
    <ScrollToTop />
    <Navbar />
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/about' element={<About />} />
      <Route path='/projects' element={<Projects />} />
      <Route path='/project/:projectId' element={<ProjectDetails />} />
      <Route path='/blogs' element={<Blogs />} />
      <Route path='/blog/:blogId' element={<BlogDetails />} />
      <Route path='/services' element={<Services />} />
      <Route path='/service/:serviceId' element={<ServicesDetails />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/events' element={<Events  />} />
      <Route path='/event/:eventUrl' element={<EventsDetails  />} />
      <Route path='*' element={<NotFound  />} />
    </Routes>
    <Footer />
    </div>
  );
}

export default App;
